import {NewJoiner} from "./Model";
import {HierarchyEmployee} from "../util/EmployeeHierarchy";
import {RemoteValue} from "../util/RemoteValue";
import {useEmployeeNeighbourhoodStore} from "./EmployeeNeighbourhoodStore";
import {useEmployeeHierarchyStore} from "./EmployeeHierarchyStore";
import {useMemo} from "react";
import {useNewJoinerStore} from "./NewJoinerStore";
import {associateBy} from "../util/MapUtil";

export type ResolvedNewJoiner = NewJoiner & {
    employee: HierarchyEmployee | undefined,
    manager: HierarchyEmployee | undefined,
}


export function useResolvedNewJoinerStore(): RemoteValue<ResolvedNewJoiner[]> {
    const employeeNeighbourhoods = useEmployeeNeighbourhoodStore(state => state.remoteValue);
    const hierarchy = useEmployeeHierarchyStore(employeeNeighbourhoods);
    const newJoiners = useNewJoinerStore(state => state.remoteValue);

    return useMemo(() =>
            RemoteValue
                .combine({hierarchy, newJoiners})
                .map(({hierarchy, newJoiners}) => {
                    const id2employee = associateBy(hierarchy.employees, employee => employee.id);
                    return newJoiners.map(joiner => {
                        const employeeNode = joiner.person.type === 'existing' ? id2employee.get(joiner.person.employee.id) : undefined;
                        return ({
                            ...joiner,
                            employee: employeeNode,
                            manager: employeeNode?.parent?.type === 'node'
                                ? employeeNode.parent
                                : (joiner.person.type === 'new' && joiner.person.manager)
                                    ? (id2employee.get(joiner.person.manager.id))
                                    : undefined,
                        });
                    });
                }),
        [hierarchy, newJoiners]
    );
}
